import ProductCard from "../atoms/product-card/ProductCard"

import "./BlackFridayCalendar.css"

export interface IPromotionsCalendarProps {
  cards: any[]
  disableLinks?: boolean
}

const PromotionsCalendar = ({ cards, disableLinks }: IPromotionsCalendarProps) => {
  return (
    <section className="bf-promotions-calendar">
      <h2 className="bf-promotions-calendar-title">Todas las ofertas</h2>
      <div className="bf-promotions-calendar-grid">
        {cards.map((card, i) => (
          <ProductCard
            key={i}
            date={card.date}
            discount={card.discount}
            title={card.cardTitle ? card.cardTitle : card.title}
            isPast={card.isPast}
            showDiscountPreview={card.showDiscountPreview}
            goToId={!disableLinks ? card.id : undefined}
          />
        ))}
      </div>
    </section>
  )
}

export default PromotionsCalendar
